import React, { ReactElement, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { MinimalLayout } from '../layouts';
import { MainLoader } from '../components';

export function PublicRouter(): ReactElement {
  return (
    <MinimalLayout>
      <Suspense fallback={<MainLoader fullContent />}>
        <Outlet />
      </Suspense>
    </MinimalLayout>
  );
}
